import React, { useState } from 'react';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import { StaticImage } from 'gatsby-plugin-image';

import navigation from '../../utils/navigation';

const Navbar = () => {
  const [isMenuHidden, setIsMenuHidden] = useState(true);
  const isHiddenClass = isMenuHidden
    ? 'hidden'
    : 'flex flex-col gap-3 justify-center items-center py-3';
  const handleMenuClick = () => {
    if (isMenuHidden) {
      setIsMenuHidden(false);
      return;
    }
    setIsMenuHidden(true);
  };

  return (
    <nav className="sticky top-0 bg-deepBlack z-50 px-4 xl:px-0" id="start">
      <div className=" py-3 ">
        <div className="flex justify-between md:text-2xl">
          {/* logo */}
          <AnchorLink
            to={navigation.logo.link}
            className="font-bold text-transparent bg-gradient-to-r from-teal-200 
            to-lime-200 hover:bg-gradient-to-l hover:from-teal-200 hover:to-lime-200 bg-clip-text"
          >
            <StaticImage
              src="../../images/logo.png"
              alt="logo"
              className="h-10 w-10"
            />
          </AnchorLink>
          {/* links  */}
          <div className="hidden md:flex space-x-4 text-accentGray">
            <AnchorLink
              to={navigation.about.link}
              className="text-transparent bg-gradient-to-br from-accentGray to-accentGray
               texthover:bg-gradient-to-l hover:from-teal-200 hover:to-lime-200 bg-clip-text
               focus:bg-gradient-to-l focus:from-teal-200 focus:to-lime-200"
            >
              {navigation.about.name}
            </AnchorLink>
            <AnchorLink
              to={navigation.projects.link}
              className="text-transparent bg-gradient-to-br from-accentGray to-accentGray
              texthover:bg-gradient-to-l hover:from-pink-500 hover:to-orange-400 bg-clip-text
              focus:bg-gradient-to-l focus:from-pink-500 focus:to-orange-400"
            >
              {navigation.projects.name}
            </AnchorLink>
            <AnchorLink
              to={navigation.contact.link}
              className="text-transparent bg-gradient-to-br from-accentGray to-accentGray
              texthover:bg-gradient-to-l hover:from-purple-500 hover:to-pink-500 bg-clip-text
              focus:bg-gradient-to-l focus:from-purple-500 focus:to-pink-500"
            >
              {navigation.contact.name}
            </AnchorLink>
          </div>
          {/* mobile menu button */}
          <div className="mobile-menu__button md:hidden flex items-center">
            <button type="button" onClick={handleMenuClick}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      {/* mobile menu */}
      <div
        className={`${isHiddenClass} md:hidden px-4 md:px-0 divide-y divide-slate-800 divide-solid`}
      >
        <AnchorLink
          to={navigation.about.link}
          className="text-transparent bg-gradient-to-br from-accentGray to-accentGray
          texthover:bg-gradient-to-l hover:from-teal-200 hover:to-lime-200 bg-clip-text
          focus:bg-gradient-to-l focus:from-teal-200 focus:to-lime-200"
          onAnchorLinkClick={handleMenuClick}
        >
          {navigation.about.name}
        </AnchorLink>
        <AnchorLink
          to={navigation.projects.link}
          className="text-transparent bg-gradient-to-br from-accentGray to-accentGray
          texthover:bg-gradient-to-l hover:from-pink-500 hover:to-orange-400 bg-clip-text
          focus:bg-gradient-to-l focus:from-pink-500 focus:to-orange-400"
          onAnchorLinkClick={handleMenuClick}
        >
          {navigation.projects.name}
        </AnchorLink>
        <AnchorLink
          to={navigation.contact.link}
          className="text-transparent bg-gradient-to-br from-accentGray to-accentGray
          texthover:bg-gradient-to-l hover:from-purple-500 hover:to-pink-500 bg-clip-text
          focus:bg-gradient-to-l focus:from-purple-500 focus:to-pink-500"
          onAnchorLinkClick={handleMenuClick}
        >
          {navigation.contact.name}
        </AnchorLink>
      </div>
    </nav>
  );
};

export default Navbar;
